const transfeeraData = {
  COMPANY_NAME: 'Transfeera Pagamentos S.A.',
  FANTASY_NAME: 'Transfeera Instituição de Pagamento',
  COMPANY_ID: 'b3b5699a-232c-4874-b669-201b711e8061',
  CNPJ: '27.084.098/0001-69',
  POSTAL_CODE: '89202200',
  STATE: 'SC',
  CITY: 'Joinville',
  ADDRESS: 'Rua São Paulo, 31 - sala 9',
  ISPB: '27084098',
  COMPE: '593',
  DEFAULT_PIX_KEY: 'pix@transfeera.com',
  PIX_ACCOUNT_AGENCY: '1',
  PIX_ACCOUNT_NUMBER: '10'
};

module.exports = transfeeraData;
